'use strict';

/**
 * MainController - contrôleur principal du layout
 */
import appModule from '../app.module';

angular.module(appModule)
.controller('MainController', ['$scope', '$rootScope', '$translate', '$timeout', '$interval', 'Auth', '$window', '$document', '$state', 'NotificationService', 'StorageService',
function($scope, $rootScope, $translate, $timeout, $interval, Auth, $window, $document, $state, NotificationService, StorageService) {

  $scope.currentLanguage = $translate.use() || 'fr';
  $scope.mobileMenuOpen = false;

  $rootScope.$on('$translateChangeSuccess', function(e, data) {
    $scope.currentLanguage = data.language;
  });

  $scope.toggleMobileMenu = function() {
    $scope.mobileMenuOpen = !$scope.mobileMenuOpen;
  };

  $scope.$on('$stateChangeSuccess', function(e, toState) {
    $scope.mobileMenuOpen = false;
    $scope.notifOpen = false;
    _updateBreadcrumb(toState.name);
  });

  // ── Notifications ─────────────────────────────────────────────────────────
  $scope.notifications = [];
  $scope.notifCount    = 0;
  $scope.notifOpen     = false;

  NotificationService.getNotifications().then(function(items) {
    $scope.notifications = items;
    $scope.notifCount    = items.length;
  });

  $scope.toggleNotifPanel = function($event) {
    $event.stopPropagation();
    $scope.notifOpen = !$scope.notifOpen;
  };

  $scope.closeNotifPanel = function() {
    $scope.notifOpen = false;
  };

  $scope.markNotifsRead = function() {
    NotificationService.markAllRead();
    $scope.notifCount = 0;
    $scope.notifOpen  = false;
  };

  $scope.goNotif = function(notif) {
    $scope.notifOpen = false;
    $state.go(notif.state);
  };

  // Fermer le panel au clic en dehors
  $document.on('click.notif', function() {
    if ($scope.notifOpen) {
      $scope.$apply(function() { $scope.notifOpen = false; });
    }
  });

  $scope.$on('$destroy', function() {
    $document.off('click.notif');
  });

  $scope.currentYear = new Date().getFullYear();
  
  // Initialiser le mode clair/sombre
  $scope.isDarkMode = $window.localStorage.getItem('darkMode') === 'true';
  
  // Fonction pour basculer entre mode clair et sombre
  $scope.toggleDarkMode = function() {
    $scope.isDarkMode = !$scope.isDarkMode;
    $window.localStorage.setItem('darkMode', $scope.isDarkMode);
  };
  
  // Fonction pour changer de langue
  $scope.changeLanguage = function(langKey) {
    $translate.use(langKey);
    $scope.currentLanguage = langKey;
  };
  
  // Exposer les fonctions d'authentification directement au $scope
  $scope.isAuthenticated = function() {
    return Auth.isAuthenticated();
  };
  
  $scope.hasAuthority = function(authority) {
    return Auth.hasAuthority(authority);
  };
  
  $scope.hasAnyAuthority = function(authorities) {
    return Auth.hasAnyAuthority(authorities);
  };
  
  // Récupérer les informations de l'utilisateur si authentifié
  Auth.identity().then(function(user) {
    $scope.user = user;
  }).catch(function(error) {
    console.error('Erreur lors de la récupération des informations utilisateur:', error);
  });
  
  // Fonction pour gérer le header sticky - version simplifiée
  function initStickyHeader() {
    var header = document.querySelector('.main-header');
    if (!header) {
      console.error('Header element not found');
      return;
    }
    
    // Créer un wrapper pour le header si nécessaire
    var headerHeight = header.offsetHeight;
    var wrapper = document.createElement('div');
    wrapper.className = 'sticky-wrapper';
    
    // Insérer le wrapper avant le header et y déplacer le header
    if (header.parentNode) {
      header.parentNode.insertBefore(wrapper, header);
      wrapper.appendChild(header);
      wrapper.style.height = headerHeight + 'px';
    }
    
    function handleScroll() {
      var scrollPosition = window.scrollY || window.pageYOffset;
      
      // À partir d'une certaine position de défilement, on rend le header sticky
      if (scrollPosition > headerHeight) {
        header.classList.add('sticky');
        wrapper.style.height = headerHeight + 'px'; // Maintenir la hauteur du wrapper
      } else {
        header.classList.remove('sticky');
      }
    }
    
    // Attacher l'événement au défilement
    window.addEventListener('scroll', handleScroll);
    
    // Exécuter une fois au chargement
    handleScroll();
    
    // Nettoyage lors de la destruction du scope
    $scope.$on('$destroy', function() {
      window.removeEventListener('scroll', handleScroll);
    });
  }
  
  // Initialiser le header sticky après le chargement complet du DOM
  angular.element(document).ready(function() {
    initStickyHeader();
  });
  
  /* ── Déconnexion avec confirmation ────────────────────────── */
  $scope.showLogoutModal = false;

  $scope.askLogout = function() {
    $scope.showLogoutModal = true;
  };

  $scope.cancelLogout = function() {
    $scope.showLogoutModal = false;
  };

  $scope.doLogout = function() {
    $scope.showLogoutModal = false;
    _clearSessionTimers();
    Auth.logout();
    $scope.user = null;
  };

  /* ── Session timeout ──────────────────────────────────────── */
  var _warnTimer      = null;
  var _countdownTimer = null;
  var WARN_BEFORE_MS  = 5 * 60 * 1000;

  $scope.showSessionModal = false;
  $scope.sessionCountdown = 300;

  $scope.sessionCountdownFormatted = function() {
    var s = $scope.sessionCountdown;
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  };

  function _getJwtExp(token) {
    if (!token || token.startsWith('simulated')) { return null; }
    try {
      var payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp ? payload.exp * 1000 : null;
    } catch(e) { return null; }
  }

  function _clearSessionTimers() {
    if (_warnTimer)      { $timeout.cancel(_warnTimer);       _warnTimer      = null; }
    if (_countdownTimer) { $interval.cancel(_countdownTimer); _countdownTimer = null; }
    $scope.showSessionModal = false;
  }

  function _startCountdown(seconds) {
    $scope.showSessionModal = true;
    $scope.sessionCountdown = seconds;
    _countdownTimer = $interval(function() {
      $scope.sessionCountdown--;
      if ($scope.sessionCountdown <= 0) {
        _clearSessionTimers();
        $scope.doLogout();
      }
    }, 1000);
  }

  function _scheduleSessionTimer() {
    _clearSessionTimers();
    var token      = StorageService.get('authToken');
    var exp        = _getJwtExp(token);
    if (!exp) { return; }
    var now        = Date.now();
    var msToExpiry = exp - now;
    if (msToExpiry <= 0) { $scope.doLogout(); return; }
    var msToWarn   = msToExpiry - WARN_BEFORE_MS;
    var warnSecs   = Math.max(0, Math.floor(Math.min(msToExpiry, WARN_BEFORE_MS) / 1000));
    if (msToWarn <= 0) {
      _startCountdown(warnSecs);
    } else {
      _warnTimer = $timeout(function() { _startCountdown(warnSecs); }, msToWarn);
    }
  }

  $scope.stayConnected = function() {
    _clearSessionTimers();
    _scheduleSessionTimer();
  };

  $rootScope.$on('auth:login-success',    function() { $timeout(_scheduleSessionTimer, 500); });
  $rootScope.$on('auth:session-restored', function() { $timeout(_scheduleSessionTimer, 500); });
  if (Auth.isAuthenticated()) { $timeout(_scheduleSessionTimer, 1000); }

  /* ── Breadcrumb ───────────────────────────────────────────── */
  var BC = {
    'main.open-budget-general':        [{ l: 'Open Budget' },        { l: 'Budget général' }],
    'main.open-budget-local':          [{ l: 'Open Budget' },        { l: 'Budget local' }],
    'main.open-budget-citoyen':        [{ l: 'Open Budget' },        { l: 'Budget citoyen' }],
    'main.open-budget-investissements':[{ l: 'Open Budget' },        { l: "Budget d'investissements" }],
    'main.contrats-petroliers':        [{ l: 'Secteur pétrolier' },  { l: 'Contrats pétroliers' }],
    'main.autorisations-recherche':    [{ l: 'Secteur pétrolier' },  { l: 'Autorisations de recherche' }],
    'main.autorisations-exploitation': [{ l: 'Secteur pétrolier' },  { l: "Autorisations d'exploitation" }],
    'main.conventions-minieres':       [{ l: 'Secteur minier' },     { l: 'Conventions minières' }],
    'main.titres-miniers':             [{ l: 'Secteur minier' },     { l: 'Titres miniers' }],
    'main.autorisations-minieres':     [{ l: 'Secteur minier' },     { l: 'Autorisations minières' }],
    'main.textes-officiels':           [{ l: 'Documents' },          { l: 'Textes officiels' }],
    'main.publications':               [{ l: 'Documents' },          { l: 'Publications' }],
    'main.videotheque':                [{ l: 'Vidéothèque' }],
    'main.forum':                      [{ l: 'Forum' }],
    'main.contact':                    [{ l: 'Contactez-nous' }],
    'main.mon-compte':                 [{ l: 'Mon compte' }],
    'main.favoris':                    [{ l: 'Mes favoris' }],
    'main.applications':               [{ l: 'Applications' }]
  };

  $scope.breadcrumb = [];

  function _updateBreadcrumb(name) {
    $scope.breadcrumb = BC[name] || [];
  }

  _updateBreadcrumb($state.current ? $state.current.name : '');

  /* ── Scope destroy ────────────────────────────────────────── */
  $scope.$on('$destroy', function() {
    _clearSessionTimers();
  });
}]);
